<template>
  <div v-if="getTags.length>0" class="tags">
    <Tag 
     v-for="(item,index) in getTags" :key="index" 
    type="dot" name="1" closable checkable
    :color="getCheckId == item.id?'primary':'#ddd'"
     @on-close="closeTag(item.id)"
     @on-change="changeTag(item.id)">
    {{item.name}}</Tag>
  </div>
</template>
<script>
import {mapGetters} from "vuex"
export default {
  methods: {
    closeTag(id) {
    //   let tags = this.getTags;
    //     if(tags.length <= 1){
    //         return ;
    //     }
    //     tags.splice(id,1);
    //     console.log(tags)
    //     id==0?this.$router.push(tags[id].path):this.$router.push(tags[id-1].path);
        this.$store.commit('closeTags',id);
    },
    changeTag(c){
     this.$store.commit('setCheckId',c)
     this.getTags.map(item =>{
       if(item.id === c){
         this.$store.commit('setSelected',c);
         this.$router.push(item.path);
       }
     })
    }
  },
  computed:{
    ...mapGetters(['getTags','getCheckId'])
  },
};
</script>




// WEBPACK FOOTER //
// src/views/index/YnTags.vue